import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, LayoutDashboard, Map, GitMerge, Bot, Share2, FileText, Camera, WifiOff } from 'lucide-react';
import CoverageDashboard from '../../components/sitewalk/CoverageDashboard';
import FloorPlanCanvas from '../../components/sitewalk/FloorPlanCanvas';
import MatchAssistant from '../../components/sitewalk/MatchAssistant';
import AiReviewQueue from '../../components/sitewalk/AiReviewQueue';
import SharingManager from '../../components/sitewalk/SharingManager';
import RegisterReports from '../../components/sitewalk/RegisterReports';
import OfflineWalkPanel from '../../components/sitewalk/OfflineWalkPanel';

const TABS = [
  { key: 'coverage', label: 'Coverage', icon: LayoutDashboard },
  { key: 'floorplan', label: 'Floor Plan', icon: Map },
  { key: 'match', label: 'Match Assistant', icon: GitMerge },
  { key: 'ai', label: 'AI Review Queue', icon: Bot },
  { key: 'sharing', label: 'Contractor Sharing', icon: Share2 },
  { key: 'reports', label: 'Registers & Reports', icon: FileText },
  { key: 'offline', label: 'Offline Walk', icon: WifiOff },
];

export default function SiteWalkOps() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState('coverage');

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex items-center gap-3 mb-4">
          <button onClick={() => navigate(`/app/projects/${projectId}/site-walks`)} className="p-2 rounded-lg hover:bg-slate-100" data-testid="ops-back-btn"><ArrowLeft className="w-5 h-5" /></button>
          <div>
            <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><Camera className="w-6 h-6 text-sky-600" /> 360° Operations</h1>
            <p className="text-sm text-slate-500">Factual coverage, floor-plan navigation, match assistance, AI review, sharing & reporting.</p>
          </div>
        </div>

        <div className="flex gap-1 overflow-x-auto border-b border-slate-200 mb-4" data-testid="ops-tabs">
          {TABS.map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`ops-tab-${t.key}`}
              className={`flex items-center gap-1.5 px-3 py-2 text-sm whitespace-nowrap border-b-2 -mb-px ${tab === t.key ? 'border-sky-600 text-sky-700 font-medium' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
              <t.icon className="w-4 h-4" /> {t.label}
            </button>
          ))}
        </div>

        <div data-testid={`ops-panel-${tab}`}>
          {tab === 'coverage' && <CoverageDashboard projectId={projectId} />}
          {tab === 'floorplan' && <FloorPlanCanvas projectId={projectId} />}
          {tab === 'match' && <MatchAssistant projectId={projectId} />}
          {tab === 'ai' && <AiReviewQueue projectId={projectId} />}
          {tab === 'sharing' && <SharingManager projectId={projectId} />}
          {tab === 'reports' && <RegisterReports projectId={projectId} />}
          {tab === 'offline' && <OfflineWalkPanel projectId={projectId} />}
        </div>
      </div>
    </div>
  );
}
